import TablePage from '@/found/components/table_page';
import request from '@/found/utils/request';
import { ProcessLog } from '@/found/modules';
import Form from '../form/index';
import ContractClosureForm from '../form/contract_closure.vue';

export default {
  extends: TablePage,
  components: {
    Form,
    ProcessLog,
    ContractClosureForm,
  },
  name: 'contract_management',
  data() {
    return {

    };
  },
  created() {
    this.getConfigList('page_list');
  },

  methods: {
    clickVisible({ row, val: { code } }) {
      const { approveStatus, processCode, contracStatus } = row;
      if (code === 'edit' && (approveStatus !== '0' && approveStatus !== '3')) {
        return false;
      }
      if (code === 'process_log' && !processCode) {
        return false;
      }
      if (code === 'contract_closure' && (approveStatus !== '2' || contracStatus === '2')) {
        return false;
      }
      return true;
    },
    modalClick({ val, row }) {
      console.log(val.code);
      if (val.code === 'view') {
        this.modalConfig.title = '查看';
        this.formConfig = {
          row,
          code: val.code,
        };
        this.openFull();
      }
      if (val.code === 'add') {
        this.modalConfig.title = '新增';
        this.formConfig = {
          code: val.code,
        };
        this.openFull();
      }
      if (val.code === 'edit') {
        this.modalConfig.title = '编辑';
        this.formConfig = {
          code: val.code,
          id: row.id,
          row,
        };
        this.openFull();
      }
      if (val.code === 'process_log') {
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row: { processNo: row.processCode },
        };

        this.modalConfig.title = '流程日志';

        this.formName = 'ProcessLog';
        this.openDrawer();
      }
      if (val.code === 'contract_closure') {
        this.formName = 'ContractClosureForm';
        this.modalConfig = {
          title: '合同关闭',
          width: '80%',
        };
        this.formConfig = {
          ...this.formConfig,
          code: val.code,
          row,
        };
        this.openDrawer();
      }
    },
  },
};
